
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/sdk/point-of-sale/android",
      function () {
        return require("private-next-pages/docs/sdk/point-of-sale/android.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/sdk/point-of-sale/android"])
      });
    }
  